<!--
	作者：shujuan sun
	时间：2017-04-10
	描述：车辆状态图标
-->
<template>
	 <!--车辆监控页面_车辆状态解释开始-->
	<div class="icon_indicated" :class="{'activ_magnify':magnify,'midSizeL':leftSize==1,'maxSizeL':leftSize==2,'minSizeL':leftSize==0}">
	  <ul>
	    <li class="bgc_01"><em><img src="../../../assets/project/images/map/car_icon_11.png" width="14" height="24" alt=""/></em><span>行驶</span></li>
	    <li class="bgc_02"><em><img src="../../../assets/project/images/map/car_icon_12.png" width="14" height="24" alt=""/></em><span>停车</span></li>
	    <li class="bgc_03"><em><img src="../../../assets/project/images/map/car_icon_13.png" width="14" height="24" alt=""/></em><span>离线</span></li>
	    <li class="bgc_04"><em><img src="../../../assets/project/images/map/car_icon_14.png" width="14" height="24" alt=""/></em><span>预警</span></li>
	    <li class="bgc_05"><em><img src="../../../assets/project/images/map/car_icon_15.png" width="14" height="24" alt=""/></em><span>追车</span></li>
	  </ul>
	</div>
	  <!--车辆监控页面_车辆状态解释结束-->
</template>
<script>
	import {mapState} from 'vuex'
	
	export default{
		name:'MenuStatus',		
		data(){
			return {
				
			}
		},
		computed:mapState({ 
			leftSize:state=>state.monitor.leftSize,
			magnify:state=>state.monitor.magnify
		}),
		methods: {
		},
		mounted: function() {
			
			
		}
		
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// MenuStatus.vue?2d3be316